import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Header } from "./components/layout/Header";
import { MobileNav } from "./components/layout/MobileNav";
import { Footer } from "./components/layout/Footer";
import { CartDrawer } from "./components/cart/CartDrawer";
import HomePage from "./pages/HomePage";
import MenuPage from "./pages/MenuPage";
import LocationsPage from "./pages/LocationsPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderStatusPage from "./pages/OrderStatusPage";
import CateringPage from "./pages/CateringPage";
import PanelPage from "./pages/PanelPage";

function App() {
  return (
    <ThemeProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/menu" element={<MenuPage />} />
                <Route path="/ubicaciones" element={<LocationsPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/pedido/:orderId" element={<OrderStatusPage />} />
                <Route path="/catering" element={<CateringPage />} />
                <Route path="/panel" element={<PanelPage />} />
              </Routes>
            </main>
            <Footer />
            <MobileNav />
            <CartDrawer />
            <Toaster 
              position="top-center" 
              toastOptions={{
                className: 'font-body',
                style: {
                  background: 'hsl(var(--card))',
                  border: '1px solid hsl(var(--border))',
                  color: 'hsl(var(--foreground))',
                },
              }}
            />
          </div>
        </BrowserRouter>
      </CartProvider>
    </ThemeProvider>
  );
}

export default App;
